var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasOldOrder)?_c('div',{staticClass:"old-order"},[_c('div',{staticClass:"tips-detail os-font-14-500"},[_vm._v(" "+_vm._s(_vm.tips)+"，"),_c('span',{staticClass:"go-order",on:{"click":_vm.goOrderList}},[_vm._v("点击查看")])]),_c('div',{staticClass:"tip-close",on:{"click":_vm.closeOderTip}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }